import React from 'react'
import { ProductTime } from '../ProductTime/ProductTime'
import { Card } from 'react-bootstrap'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import Loader from '../Loader/Loader'
import { BackupSettings } from './BackupSettigns/BackupSettings'
import { GeneralSettings } from './GeneralSettings/GeneralSettings'
import { useAppSelector } from '../../hooks/useAppSelector'
import { selectProductSystemActions } from '../../store/selectors/systemActionsSelectors'
import { useSessionStorage } from '../../hooks/useSessionStroage'

const tabNames = ['general', 'backup']

interface Props {
    guid: string
}

export const Settings = ({ guid }: Props) => {
    const [activeTab, setActiveTab] = useSessionStorage(
        'settingsTabs',
        tabNames[0]
    )

    const productSystemActions =
        useAppSelector(selectProductSystemActions(guid)) ?? {}
    const {
        get_general_settings: hasGeneralSettings,
        get_backup_settings: hasBackupSettings,
    } = productSystemActions

    return (
        <Card className="vh-full d-flex justify-content-center">
            <Card.Header className="nav-dark d-flex justify-content-between p-4 pb-0">
                <Card.Title>SETTINGS</Card.Title>
                <Card.Title>
                    <ProductTime
                        guid={guid}
                        className="pt-2 pb-2 nav-dark"
                    />
                </Card.Title>
            </Card.Header>
            <Card className="border-none">
                <Card.Body className="vh-user-card pt-0 p-0 pb-1 ">
                    <div className="d-flex flex-1 m-4 mb-2 p-1 app-bg-header">
                        <button
                            className={`w-100 btn-clean ${activeTab === tabNames[0] ? 'bg-white' : ''}`}
                            onClick={() => setActiveTab(tabNames[0])}
                        >
                            General
                        </button>
                        <button
                            className={`w-100 btn-clean ${activeTab === tabNames[1] ? 'bg-white' : ''}`}
                            onClick={() => setActiveTab(tabNames[1])}
                        >
                            Database backup
                        </button>
                    </div>
                    <OverlayScrollbarsComponent className="h-100 ps-4 pe-4">
                        <React.Suspense
                            fallback={
                                <div className="vh-full d-flex justify-content-center">
                                    <Loader />
                                </div>
                            }
                        >
                            {activeTab === tabNames[0] &&
                                hasGeneralSettings && (
                                    <GeneralSettings guid={guid} />
                                )}
                            {activeTab === tabNames[1] &&
                                (hasBackupSettings ? (
                                    <BackupSettings guid={guid} />
                                ) : (
                                    <h5 className="text-secondary vh-full d-flex align-items-center justify-content-center">
                                        Product does not support database backup
                                    </h5>
                                ))}
                        </React.Suspense>
                    </OverlayScrollbarsComponent>
                </Card.Body>
            </Card>
        </Card>
    )
}
